var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #565d6d;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.7px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.65,18.21v-1.82c0-.97-.38-1.9-1.07-2.58-.68-.68-1.61-1.07-2.58-1.07h-5.47c-.97,0-1.9.38-2.58,1.07-.68.68-1.07,1.61-1.07,2.58v1.82M13.65,1.91c.78.2,1.48.66,1.97,1.3.49.64.76,1.42.76,2.23s-.27,1.59-.76,2.23c-.49.64-1.19,1.1-1.97,1.3M19.12,18.21v-1.82c0-.81-.27-1.59-.77-2.23-.5-.64-1.19-1.1-1.97-1.3M10.91,5.44c0,2.02-1.63,3.65-3.65,3.65s-3.65-1.63-3.65-3.65,1.63-3.65,3.65-3.65,3.65,1.63,3.65,3.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/user-management.0118057721a60271c48834adbee4ab66.svg";
export { ForwardRef as ReactComponent };